import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';

const ROLE_OPTIONS = [
    { key: 'professors', value: 'Profesori', text: 'Profesori' },
    { key: 'assistants', value: 'Asistenti', text: 'Asistenti' }
];

const StaffFiltersForm = ({ faculty, role, handleInputChange }) => (
    <Form.Group widths="three">
        <Form.Field required>
            <label htmlFor="role">Uloga</label>
            <Form.Select
                id="role"
                value={role}
                onChange={handleInputChange}
                name="role"
                options={ROLE_OPTIONS}
                fluid
                placeholder="Odaberite ulogu"
                disabled={!faculty}
            />
        </Form.Field>
        <Form.Field />
        <Form.Field />
    </Form.Group>
);

StaffFiltersForm.propTypes = {
    faculty: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    role: PropTypes.string,
    handleInputChange: PropTypes.func.isRequired
};

StaffFiltersForm.defaultProps = {
    faculty: '',
    role: ''
};

export default StaffFiltersForm;




// WEBPACK FOOTER //
// ./src/views/GenerateUsers/StaffFiltersForm.js